<template>
  <div class="section testimonial-section">
		<div class="container">
			<div class="row">
				<div class="col-sm-12 no-padding">
					<!-- slider for desktop -->
					<div class="slider-container">
						<div class="define-heading">
							<h2 class="hf_heading02 slider-heading" v-if="heading!=='' && heading!== undefined">{{ heading }}</h2>
							<p class="hf_blogbody" v-if="subtitle!=='' && subtitle!== undefined">{{ subtitle }}</p>
						</div>
						<div class="testimonial-slider">
							<div class="testimonialSlider">
								<!-- single-slide -->
								<div class="single-slide" v-for="(singleSlideContent, slideIndex) in loops" :key="slideIndex">
									<div class="slider-content">
										<div class="quote"><img src="/img/quote.svg" alt=""></div>
										<p class="hf_bodytext02" v-html="singleSlideContent.post_content"></p>
									</div>
									<div class="user-content">
										<div class="user-image">
											<img :src="singleSlideContent.image_url" alt="">
										</div>
										<div class="user-info">
											<h4 class="hf_heading06">{{ singleSlideContent.post_title }}</h4>
											<p class="hf_bodytext02">{{ singleSlideContent.designation }}</p>
										</div>
									</div>
								</div>
								<!-- single-slide -->
							</div>
						</div>
					</div>
					<!-- end slider for desktop -->
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
  data() {
    return {};
  },
  props: {
    heading: { type: String, default: '' },
    subtitle: { type: String, default: '' },
    loops:{ type: Array, default:[] },
  },
  methods: {},
};
</script>

<style lang="scss" scoped></style>
